import React, { useState, useEffect } from "react";
import Select from "react-select";

function CustomDropdown({
  value,
  name,
  handleChange,
  placeholder,
  options,
  handleGetOptionValue,
  handleGetOptionName,
  isDisabled = false,
  customClasses,
  hideDropdownIndicator = false,
}) {
  const [isFocused, setIsFocused] = useState(false);


  useEffect(() => {
    if (value) {
      setIsFocused(true);
    }
  }, [value]);

  return (
    <div className="relative w-full bg-white">
      {/* Floating Label */}
      <label
        className={`absolute left-3 transition-colors duration-150 z-10 bg-white px-1
          ${
            isFocused || value
              ? "top-[-10px] text-xs text-[#201F1E] px-1 bg-white"
              : "top-2/4 text-[#201F1E]/80 text-sm -translate-y-1/2"
          }
        `}
      >
        {placeholder}
      </label>

      {/* Select Dropdown */}
      <Select
        value={value}
        name={name}
        onChange={(selectedOption) => {
          handleChange(selectedOption);
          setIsFocused(!!selectedOption);
        }}
        onFocus={() => setIsFocused(true)}
        onBlur={() => {
          if (!value) setIsFocused(false);
        }}
        className={`mt-1 ${customClasses}`}
        options={options || []}
        getOptionValue={handleGetOptionValue}
        getOptionLabel={handleGetOptionName}
        isDisabled={isDisabled}
        placeholder="" // Removes the extra "Select..." label
        menuPortalTarget={document.body} // Ensures menu appears above everything
        styles={{
          control: (base, state) => ({
            ...base,
            borderColor: "#201F1E",
            borderWidth: "1px",
            borderRadius: "4px",
            boxShadow: state.isFocused ? "0 0 0 1px #201F1E" : "none",
            transition: "border-color 150ms ease, box-shadow 150ms ease",
            "&:hover": {
              borderColor: "#201F1E",
            },
            minHeight: "38px",
            height: "38px",
            padding: "0 8px",
            backgroundColor: "#FFFFFF",
          }),
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999, // Higher z-index than the floating label
          }),
          menu: (base) => ({
            ...base,
            zIndex: 9999,
            boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
            borderRadius: "4px",
            border: "1px solid #201F1E",
          }),
          option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected ? "#646464" : state.isFocused ? "#F9FAFB" : "white",
            color: state.isSelected ? "#201F1E" : "#201F1E",
            "&:hover": {
              backgroundColor: "#D1D1D1",
            },
            fontSize: "0.875rem",
            padding: "8px 12px",
          }),
          valueContainer: (base) => ({
            ...base,
            padding: "2px 8px",
            fontSize: "0.875rem",
          }),
          indicatorsContainer: (base) => ({
            ...base,
            height: "36px",
          }),
          dropdownIndicator: (base) => ({
            ...base,
            padding: "4px",
            color: "#201F1E",
            display: hideDropdownIndicator ? 'none' : base.display,
            "&:hover": {
              color: "#201F1E",
            },
          }),
          singleValue: (base) => ({
            ...base,
            color: "#201F1E",
          }),
          placeholder: (base) => ({
            ...base,
            color: "#201F1E",
          }),
          indicatorSeparator: (base) => ({
            ...base,
            display: hideDropdownIndicator ? 'none' : base.display,
          }),
        }}
      />
    </div>
  );
}

export default CustomDropdown;